import { Component, OnInit, Input } from '@angular/core';
import { ConexionService } from 'src/app/servicios/conexion.service';
import { UtilidadesService } from 'src/app/servicios/utilidades.service';

@Component({
  selector: 'app-grafico-actividad-usuarios',
  templateUrl: './grafico-actividad-usuarios.component.html',
  styleUrls: ['./grafico-actividad-usuarios.component.scss'],
})
export class GraficoActividadUsuariosComponent implements OnInit {
  @Input() Fecha1;
  @Input() Fecha2;

  Data=[]

  usuario ="todos";
  Usuarios = []
  buscando = "";

  tipog:any ="below"

  hora: number = 0;

  constructor(private utilidades: UtilidadesService, private conexion :ConexionService) { }

  ngOnInit() {
    this.getUsuarios()
  }

  ngOnChanges(): void {
    this.getDatosActividadUsuarioFecha()
  }

  FormatoSegunLaHora(fecha){
    if(this.hora){
      return this.utilidades.FormatoFecha(fecha, "dd/MM/yy h:m a")
    }else{
      return this.utilidades.FormatoFecha(fecha, "dd/MM/yyyy")
    }
  }
  
  getDatosActividadUsuarioFecha() {
    this.conexion.getDatosActividadUsuarioFecha(this.usuario, this.Fecha1, this.Fecha2, this.hora).subscribe((resp) => {
      this.utilidades.Depuracion(resp, "console", "")
      if (resp.Respuesta == "Exito") {
        let datos = []
        for(let i of resp.Datos){
          datos.push(
            {"value": Number(i.Cantidad),
            "name":this.FormatoSegunLaHora(i.Fecha)}
            
          )
        }
        this.Data = [
          {
            "name": "Actividad de usuarios",
            "series": datos
          }
        ]
      }
    }, (err) => {
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)

      this.utilidades.ValidarUser(err)
    })
  }


  getUsuarios() {
    this.utilidades.Loading("Cargando usuarios")
    this.conexion.getUsuarios("todos").subscribe((resp) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Depuracion(resp, "console", "")
      if (resp.Respuesta == "Exito") {
        this.Usuarios = resp.Datos
      }
    }, (err) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)

      this.utilidades.ValidarUser(err)
    })
  }

}
